import { __spreadArrays } from "tslib";
import React, { useCallback, useContext, useEffect } from 'react';
import classnames from 'classnames';
import { DropdownStateContext } from '../../Dropdown/DropdownStateManager/DropdownStateContext';
import StandardMenu from '../../Dropdown/MenuPreset/StandardMenu';
import { BiEventType } from '../../biLogger/constants';
import { gallectionTypeToResourceType } from '../../types/gallection';
import FolderInfo from './FolderInfo';
import FolderThumb from './FolderThumb';
import folderDropdownDesktopStyles from './FolderDropdownDesktop.scss';
var hasSubFolders = function (folder) {
    return folder.hasSubfolders || (folder.subfolders && folder.subfolders.length > 0);
};
var FolderDropdownDesktopMenu = function (_a) {
    var id = _a.id, folders = _a.folders, filterEmpty = _a.filterEmpty, currentFolder = _a.currentFolder, hasMore = _a.hasMore, setSelectedFolderId = _a.setSelectedFolderId, fetchMore = _a.fetchMore;
    var _b = useContext(DropdownStateContext), isOpen = _b.isOpen, closeDropdown = _b.closeDropdown;
    var selectFolder = useCallback(function (folderId) {
        setSelectedFolderId(folderId);
        closeDropdown();
    }, [setSelectedFolderId, closeDropdown]);
    useEffect(function () {
        if (isOpen && hasMore && fetchMore) {
            fetchMore();
        }
    }, [isOpen, hasMore, fetchMore]);
    if (!isOpen) {
        return null;
    }
    var menuItems = folders
        .flatMap(function (folder) { var _a; return __spreadArrays([folder], ((_a = folder.subfolders) !== null && _a !== void 0 ? _a : [])); })
        .filter(function (folder) { return !filterEmpty || folder.size > 0 || hasSubFolders(folder); })
        .map(function (folder, index) { return ({
        label: folder.name,
        value: folder.folderId,
        biData: {
            evid: BiEventType.ITEM_CLICK,
            rank: index,
            creatorid: folder.owner.useridUuid,
            typeid: gallectionTypeToResourceType(folder.type),
            itemid: folder.folderId,
        },
        complexLabel: (React.createElement(React.Fragment, null,
            React.createElement(FolderInfo, { folder: folder }),
            React.createElement(FolderThumb, { folder: folder, hasSubfolders: hasSubFolders(folder) }))),
        className: classnames(folderDropdownDesktopStyles['menu-item'], currentFolder &&
            currentFolder.folderId === folder.folderId &&
            folderDropdownDesktopStyles['selected']),
    }); });
    return (React.createElement(StandardMenu, { id: id, className: folderDropdownDesktopStyles['menu'], items: menuItems, onSelect: selectFolder, scrollable: true }));
};
FolderDropdownDesktopMenu.displayName = 'FolderDropdownDesktopMenu';
export default FolderDropdownDesktopMenu;
//# sourceMappingURL=FolderDropdownDesktopMenu.js.map